import { merchantApi } from '@/config/axios'
import type { FilePageQuery, FileMaterialGroupsVO, FileUploadRespVO } from '@/api/infra/file'

export const getMaterialPage = (params: FilePageQuery) =>
  merchantApi.get({ url: '/merchant-api/infra/file/material-page', params })

export const getMaterialGroups = () =>
  merchantApi.get<FileMaterialGroupsVO>({ url: '/merchant-api/infra/file/material-groups' })

export const uploadFileDetail = (data: any, onUploadProgress?: Function) =>
  merchantApi.upload<FileUploadRespVO>({
    url: '/merchant-api/infra/file/upload-detail',
    data,
    onUploadProgress
  })
